import { lazy } from 'react';

const Routes = () => [
  {
    path: '/',
    component: lazy(() => import('../pages/Home')),
    exact: true,
    isPrivate: false
  },
  {
    path: '/cong-cu-holland',
    component: lazy(() => import('../pages/Holland')),
    isPrivate: false,
    loginGate: true
  },
  {
    path: '/cong-cu-liet-ke-ky-nang',
    component: lazy(() => import('../pages/EmployabilitySkills')),
    isPrivate: false,
    loginGate: true
  },
  {
    path: '/cong-cu-mbti',
    component: lazy(() => import('../pages/MBTI')),
    isPrivate: false,
    loginGate: true
  },
  {
    path: '/cong-cu-gia-tri-song',
    component: lazy(() => import('../pages/WorkingValues')),
    isPrivate: false,
    loginGate: true
  },
  {
    path: '/cong-cu-vong-tron-cuoc-doi',
    component: lazy(() => import('../pages/LifeCycle')),
    isPrivate: false,
    loginGate: true
  },
  {
    path: '/lich-su',
    component: lazy(() => import('../pages/Results')),
    isPrivate: true
  },
  {
    path: '/portfolio',
    component: lazy(() => import('../pages/Portfolio')),
    isPrivate: true
  },
  {
    path: '/getSurveyResult/:id/slug/:slug',
    component: lazy(() => import('../pages/SingleResult')),
    isPrivate: false
  },
  {
    path: '/attendance',
    component: lazy(() => import('../pages/Attendance')),
    isPrivate: false
  },
  {
    path: '/smart',
    component: lazy(() => import('../pages/Smart')),
    isPrivate: true
  },
  {
    path: '/grow',
    component: lazy(() => import('../pages/Grow')),
    isPrivate: true
  }
];

export default Routes;
